module.exports = __webpack_public_path__ + "img/pexels-anfisa-eremina-2543042-180.eab76a0b.jpg";